import { TeamService } from "./TeamService";

export { TeamService };
